module.exports = __webpack_public_path__ + "static/microphone-ce64b891146290fd6b257c33b72de822.svg";